import { render, staticRenderFns } from "./rask.vue?vue&type=template&id=8855d590&scoped=true&"
import script from "./rask.vue?vue&type=script&lang=js&"
export * from "./rask.vue?vue&type=script&lang=js&"
import style0 from "./rask.vue?vue&type=style&index=0&id=8855d590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8855d590",
  null
  
)

export default component.exports